import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./locales/i18n";
import { Plugin } from "vue-fragment";

import "./config/index";
import "./components/index";

import "./plugins/axios";
import "./plugins/vant";

import "./styles/common.less";
import "./scripts/index";
import config from "@/config";

Vue.config.productionTip = false;
Vue.use(Plugin);
Vue.mixin({
    data() {
        return {
            AppConfigMixIn: config
        };
    }
});
new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount("#app");
